import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import makeStyles from "@material-ui/styles/makeStyles";

const FootermenuItem = lazy(() =>
	import(/* webpackChunkName: "footermenuItem" */ "./footermenuItem")
);

const useStyles = makeStyles(theme => ({
	footermenu: {
		"& ul": {
			listStyle: "none"
		},
		"& > ul ": {
			[theme.breakpoints.up("md")]: {
				display: "grid",
				gridColumnGap: theme?.spacing(3),
				gridRowGap: theme?.spacing(2),
				gridTemplateColumns: "repeat(4, 25%)"
			},
			[theme.breakpoints.up("xl")]: {
				gridColumnGap: theme?.spacing(6),
				gridRowGap: theme?.spacing(3)
			}
		},
		"& ul ul": {
			display: "none",
			[theme.breakpoints.up("md")]: {
				display: "block"
			}
		}
	}
}));

const Footermenu = ({ footermenu }) => {
	const css = useStyles();

	return (
		<div className={clsx("mco-footer-02__footermenu", css.footermenu)}>
			<ul>
				{footermenu?.items?.map(item => {
					return (
						<li key={item.id}>
							<Suspense fallback={<></>}>
								<FootermenuItem
									icon={item.icon?.filename}
									level={1}
									link={item.link}
									selected={item.selected}
									target={item.target}
									title={item.title}
								/>
							</Suspense>
							{item?.items && item?.items.length > 0 && (
								<ul>
									{item?.items?.map(subItem => {
										return (
											<li style={{ display: "table" }} key={subItem.id}>
												<Suspense fallback={<></>}>
													<FootermenuItem
														icon={subItem.icon?.filename}
														level={2}
														link={subItem.link}
														selected={subItem.selected}
														target={subItem.target}
														title={subItem.title}
													/>
												</Suspense>
											</li>
										);
									})}
								</ul>
							)}
						</li>
					);
				})}
			</ul>
		</div>
	);
};

Footermenu.propTypes = {
	footermenu: PropTypes.object.isRequired
};

export default Footermenu;
